<template>
  <div class="bg-more sticky-top">
    <div class="container">
      <nav class="navbar navbar-expand-md navbar-dark bg-more">
        <h1 class="logo">
          <router-link class="navbar-brand text-primary" to="/">
            LeapflyWine
          </router-link>
        </h1>

        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="el-icon-menu"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
          <div class="d-none d-md-block ml-auto">
            <ul class="navbar-nav ml-auto">
              <li class="nav-item">
                <router-link class="nav-link text-primary" to="/">{{$t('navbar.homeFormat')}}</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link mx-md-2 text-primary" to="/warehouse">{{$t('navbar.warehouseFormat')}}</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link mx-md-2 text-primary" to="/wines">{{$t('navbar.wineFormat')}}</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link ml-md-2 text-primary" to="/contact">{{$t('navbar.contactFormat')}}</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link mx-md-2 text-primary" to="/sellwines">{{$t('navbar.sellwinesFormat')}}</router-link>
              </li>
              <li class="nav-item">
                <el-switch
                  class="nav-link mx-md-2 text-primary"
                  active-icon-class="el-icon-sunny"
                  active-color="#F1F1F1"
                  inactive-color="#919191"
                  inactive-icon-class="el-icon-moon"
                  v-model="openValue"
                  @change="changeThemes"
                ></el-switch>
              </li>
              <li class="nav-item">
                <el-dropdown class="nav-link mx-md-2 text-primary" @command="handlelocale">
                  <span class="el-dropdown-link"> {{ $t("Language") }}<i class="el-icon-caret-bottom el-icon--right"></i> </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item, index) of list" :key="index" :command="item.key">{{ item.name }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </li>
            </ul>
          </div>
          <div class="d-md-none">
            <ul class="navbar-nav ml-auto">
              <li class="nav-item">
                <router-link class="nav-link text-primary" to="/">{{$t('navbar.homeFormat')}}</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link mx-md-2 text-primary" to="/warehouse">{{$t('navbar.warehouseFormat')}}</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link mx-md-2 text-primary" to="/wines">{{$t('navbar.wineFormat')}}</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link ml-md-2 text-primary" to="/contact">{{$t('navbar.contactFormat')}}</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link mx-md-2 text-primary" to="/sellwines">{{$t('navbar.sellwinesFormat')}}</router-link>
              </li>
              <li class="nav-item" style="display: flex;">
                <el-switch
                  class="nav-link mx-md-2 text-primary  mr-1"
                  active-icon-class="el-icon-sunny"
                  active-color="#F1F1F1"
                  inactive-color="#919191"
                  inactive-icon-class="el-icon-moon"
                  v-model="openValue"
                  @change="changeThemes"
                ></el-switch>
                <el-dropdown class="nav-link mx-md-2 text-primary" @command="handlelocale">
                  <span class="el-dropdown-link"> {{ $t("Language") }}<i class="el-icon-caret-bottom el-icon--right"></i> </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item, index) of list" :key="index" :command="item.key">{{ item.name }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
/* global $ */
export default {
  data() {
    return {
      carts: [],
      openValue: false,
      list: [
        { key: "en", name: "English" }, // 英语
        { key: "zh-CN", name: "中文" }, // 中文
      ],
    };
  },
  created() {},
  beforeDestroy() {
    // 清除監聽事件
    // 如果要指定哪個監聽對應方法，就需要傳入第二個參數(對應$on的設定)
    this.$bus.$off("get-cart");
  },
  watch: {
    $route() {
      $("#navbarNav").collapse("hide");
    },
  },
  methods: {
    handlelocale(value) {
      this.$i18n.locale = value;
    },
    changeThemes() {
      const root = document.documentElement;
      root.style.setProperty("--bg-color", this.openValue ? "#ffffff" : "#000000");
      root.style.setProperty("--text-color", this.openValue ? "#000000" : "#ffffff");
    },
    closeNavbar() {
      $("#navbarNav").collapse("hide");
    },
  },
};
</script>
<style scoped>
/deep/.el-switch__label.is-active {
  color: #ffb800;
}
.navbar-toggler {
  padding: 0.45rem 0.75rem;
  color: var(--text-color);
  border-color: var(--text-color);
}
</style>
